(function () {
  function publishShopifyEvent(eventName, eventData) {
    if (
      window.Shopify &&
      Shopify.analytics &&
      typeof Shopify.analytics.publish === "function"
    ) {
      Shopify.analytics.publish(eventName, eventData);
    }

    if (typeof window.gtag === "function") {
      window.gtag("event", eventName, eventData);
    }

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push(Object.assign({
      event: eventName
    }, eventData));

    console.log("Tracked:", eventName, eventData);
  }

  function getDeviceType() {
    return window.innerWidth <= 767 ? "mobile" : "desktop";
  }

  function initSectionTracking() {
    var viewedSections = {};

    var sectionNames = {
      football_bar: "football_bar_view",
      dumpling_banner: "dumpling_banner_view",
      needoh_banner: "needoh_banner_view",
      instagram_bar: "instagram_bar_view"
    };

    var trackedSections = document.querySelectorAll("[data-track-section]");

    trackedSections.forEach(function (section) {
      var sectionKey = section.getAttribute("data-track-section");
      var viewEventName = sectionNames[sectionKey];

      if (!viewEventName) return;

      if ("IntersectionObserver" in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && !viewedSections[sectionKey]) {
              viewedSections[sectionKey] = true;

              publishShopifyEvent(viewEventName, {
                section_name: sectionKey,
                page_path: window.location.pathname,
                page_url: window.location.href,
                device_type: getDeviceType()
              });
            }
          });
        }, {
          threshold: 0.5
        });

        observer.observe(section);
      } else {
        if (!viewedSections[sectionKey]) {
          viewedSections[sectionKey] = true;

          publishShopifyEvent(viewEventName, {
            section_name: sectionKey,
            page_path: window.location.pathname,
            page_url: window.location.href,
            device_type: getDeviceType()
          });
        }
      }
    });

    var trackedClicks = document.querySelectorAll("[data-track-click]");

    trackedClicks.forEach(function (element) {
      element.addEventListener("click", function () {
        var clickEventName = element.getAttribute("data-track-click");

        publishShopifyEvent(clickEventName, {
          section_name: clickEventName.replace("_click", ""),
          page_path: window.location.pathname,
          page_url: window.location.href,
          device_type: getDeviceType(),
          link_url: element.href || element.getAttribute("onclick") || ""
        });
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSectionTracking);
  } else {
    initSectionTracking();
  }
})();